import styled from 'styled-components'

import Navbar from 'components/Navbar'
import { ButtonUnstyled } from 'components/Button'

import { ReactComponent as Hamburger } from 'icons/list-lines-24.svg'
import { breakpoint } from 'utils'

export const HamburgerIcon = styled(Hamburger)`
  width: 24px;
  height: 24px;
`

export const HamburgerButton = styled(ButtonUnstyled)`
  padding: 8px 12px;
  line-height: 0; /* Needed to avoid extra height around the icon */

  /* This color should be "Light/colors.foreground.secondary.4" but given the icon composition */
  /* Opacity needs to be applied to the whole object */
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};
  opacity: 0.55;
`

export const SelectorSection = styled(Navbar.Section)`
  flex: 0 1 auto;
  /* Prevent this section from sending it's siblings of screen */
  overflow: hidden;
`

export const SidebarWrapper = styled.section`
  display: flex;
  flex-direction: column;

  /* Limit the components width, preventing items with big name to have scroll */
  width: 100%;
  height: 100%;

  background-color: ${({ theme }) => theme.colors.background.light.secondary};
`

export const WorkspaceSelectorWrapper = styled.aside`
  border-bottom: 1px solid ${({ theme }) => theme.colors.alto};
`

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
`

export const LoadingSidebarWorkspace = styled(Navbar)`
  background: none;
`

export const UserNavbarSectionWrapper = styled.div`
  margin-left: auto;
`

export const Margin = styled.div`
  padding: 16px 16px 0;
  display: flex;
  flex-direction: column;
  flex: 1;

  width: 100%;

  /* The z-index is needed so the navbar stays on top of the table header */
  z-index: ${({ theme }) => theme.zIndex[1]};

  ${breakpoint('sm')`
    padding: 40px 40px 0;
  `}
`
